<template>
  <article v-if="visit" :class="['collapsible-article', { active: element.expanded }]">
    <header class="header background-gray" @click="expanded()">
      <div
        class="article-icon has-text-centered is-size-1 has-text-grey"
        :class="visit.conditions"
      ></div>
      <div class="article-title pl-2 pr-1">
        <p>
          <span>
            {{ visit.certified_parcel.requested_parcel.parcel_cadastral_ref }}
          </span>
          <span class="unread" v-if="element.read_status == 'unread'">
            {{ $t("page.labels.unread") }}
          </span>
        </p>
        <p>
          <b>{{ element.subject }}</b>
        </p>
      </div>
      <div class="arrow"></div>
    </header>
    <div class="body article-body pa-2" v-if="element.expanded">
      <p>
        <b>{{ $t("page.labels.visit_reason") }}:</b>
      </p>
      <p>{{ visit.get_visit_reason_display }}</p>
      <p>&nbsp;</p>

      <div v-if="visit.owner_description">
        <p>
          {{ $t("page.labels.our_visitor") }} {{ visit.visitor.name }}
          {{ $t("page.labels.visit_comment") }}:
        </p>
        <p>&nbsp;</p>
        <p>
          <b>{{ visit.owner_description }}</b>
        </p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
      </div>

      <p>
        <span>{{ $t("conditions._intro") }}&nbsp;</span>
        <b v-if="visit.conditions == 'hight'">{{ $t("conditions.nice") }}</b>
        <b v-if="visit.conditions == 'medium'">{{ $t("conditions.regular") }}</b>
        <b v-if="visit.conditions == 'low'">{{ $t("conditions.bad") }}</b>
      </p>

      <div class="rating-container">
        <div v-if="visit.conditions == 'hight'" class="rating ico-nice"></div>
        <div v-if="visit.conditions != 'hight'" class="rating ico-nice-off"></div>
        <div v-if="visit.conditions == 'medium'" class="rating ico-regular"></div>
        <div v-if="visit.conditions != 'medium'" class="rating ico-regular-off"></div>
        <div v-if="visit.conditions == 'low'" class="rating ico-bad"></div>
        <div v-if="visit.conditions != 'low'" class="rating ico-bad-off"></div>
      </div>

      <div>
        <router-link
          :to="{
            name: 'parcel-detail',
            params: { id: visit.certified_parcel.requested_parcel.id },
          }"
        >
          <span class="button is-outlined back-white">Ir a la ficha de parcela</span>
        </router-link>
      </div>
    </div>
  </article>
</template>
<script>
export default {
  name: "NotificationVisitCard",
  props: ["element"],
  data() {
    return { visit: null }
  },
  mounted() {
    this.visit = this.element.entity
  },
  methods: {
    expanded() {
      this.element.expanded = !this.element.expanded
      this.$emit("expanded", this.element)
    },
  },
}
</script>
